const replace = (z) => {
  if (z.length >= 3) {
    return z.replace(/^(\d+)(\d{3})(\.(\d+))?$/ig, (z, $1, $2, $3) => {
      return replace($1, $1) + ($2 ? (',' + $2) : '') + ($3 ? $3 : '')
    })
  } else {
    return z
  }
}
export default function (Vue) {
  Vue.filter('currency', function (val, prefix, pos) {
    val = +val
    if (isNaN(val)) {
      val = 0
    }
    let z = Math.floor(val) + ''
    val = val.toFixed(pos || 0)
    let index = val.indexOf('.')
    let xiaoshu = val.substr(index)
    if (index === -1) {
      xiaoshu = ''
    }
    return (prefix || '') + replace(z) + xiaoshu
  })
  Vue.filter('lowercase', function (val) {
    return (val + '').toLowerCase()
  })
  Vue.filter('convertD', function (value) {
    try {
      var d = new Date(value), m, n;
      return d.getFullYear() + '-' + ((m = d.getMonth() + 1) > 9 ? m : '0' + m) + '-' + ((n = d.getDate()) > 9 ? n : '0' + n)
    } catch (e) {
      return value;
    }
  })
  Vue.filter('couponType', function (val) {
    switch (val) {
      case 'Cash': 
        return '现金券';
      default: 
        return val;
    }
  })
  Vue.filter('convert2html', function (val) {
    return (val + '').replace(/\n/ig, '<br/>');
  })
  Vue.filter('maskPhone', (phone) => {
    return (phone + '').replace(/(\d{3})\d+(\d{4})/ig, '$1****$2');
  })
}